import { SVGProps } from 'react';

const PlaybookIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="26"
        height="25"
        viewBox="0 0 26 25"
        fill="none"
        strokeWidth="1.33"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M17.8143 2.75403C12.0432 1.58583 4.36823 5.1651 4.28979 17.2209"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1 11.8335L4.00279 17.469L9.81573 11.9677"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M18.5454 16.3411C20.1629 16.3411 21.5356 17.7377 21.5356 19.5383C21.5355 21.3389 20.1628 22.7356 18.5454 22.7356C16.928 22.7356 15.5553 21.3389 15.5552 19.5383C15.5552 17.7377 16.9279 16.3411 18.5454 16.3411Z" />
        <line
            y1="-0.665"
            x2="7.52023"
            y2="-0.665"
            transform="matrix(0.687392 -0.726287 0.687392 0.726287 19.8308 6.46191)"
        />
        <line y1="-0.665" x2="7.52023" y2="-0.665" transform="matrix(0.687392 0.726287 -0.687392 0.726287 19.2764 1)" />
        <line
            y1="-0.665"
            x2="7.52023"
            y2="-0.665"
            transform="matrix(0.687392 -0.726287 0.687392 0.726287 2.28564 25)"
        />
        <line
            y1="-0.665"
            x2="7.52023"
            y2="-0.665"
            transform="matrix(0.687392 0.726287 -0.687392 0.726287 1.7312 19.5381)"
        />
    </svg>
);

export default PlaybookIcon;
